export enum AssignmentState {
    Unknown = 0,
    Pending = 1,
    SignedOn = 2,
    NotAssigned = 3,
    Error = 4
}

export interface CurrentAssignment {
    tripActorId?: string;
    routeName?: string;
    tripNumber?: string;
    trafficDate?: string;
    state: AssignmentState;
    stateName: string;
    vehicleId?: string;
    garageCode?: string;
    lastChangedAt?: Date;
    derivedFromMessageId?: string;
    lineName?: string;
    plannedStartTime?: string;
    plannedEndTime?: string;
    pendingTripActorIds: string[];
}
